import i18next from "translations/i18n";

i18next.addResourceBundle(
  "de",
  "global",
  {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",

    closed: "geschlossen",
    "by-arrangement": "Nach Vereinbarung",

    back: "Zurück",
    cancel: "Abbrechen",
    save: "Speichern",
    next: "Weiter",
    yes: "Ja",
    no: "Nein",

    arabic: "Arabisch",
    croatian: "Kroatisch",
    danish: "Dänisch",
    dutch: "Holländisch",
    english: "Englisch",
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    lithuanian: "Litauisch",
    polish: "Polnisch",
    russian: "Russisch",
    serbian: "Serbisch",
    spanish: "Spanisch",
    turkish: "Türkisch",
    sortBy: "Sortieren",
  },
  true,
  true
);

i18next.addResourceBundle(
  "en",
  "global",
  {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",

    closed: "Closed",
    "by-arrangement": "By Arrangement",

    back: "Back",
    cancel: "Cancel",
    save: "Save",
    next: "Next",
    yes: "Yes",
    no: "No",

    arabic: "Arabic",
    croatian: "Croatian",
    danish: "Danish",
    dutch: "Dutch",
    english: "English",
    french: "French",
    german: "German",
    italian: "Italian",
    lithuanian: "Lithuanian",
    polish: "Polish",
    russian: "Russian",
    serbian: "Serbian",
    spanish: "Spanish",
    turkish: "Turkish",
    sortBy: "Sort by",
  },
  true,
  true
);
